import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

export interface HistoryState {
  president: { id: number } | null;
  presidentModal: boolean;
  modality: string;
  appTitle: string;
}

const initialState: HistoryState = {
  president: null,
  presidentModal: false,
  modality: '',
  appTitle: '',
};

export const historySlice = createSlice({
  name: 'history',
  initialState,
  reducers: {
    setPresident: (state, action: PayloadAction<HistoryState['president']>) => {
      state.president = action.payload;
      state.presidentModal = true;
    },
    setAppTitle: (state, action: PayloadAction<HistoryState['appTitle']>) => {
      state.appTitle = action.payload;
    },
    setModality: (state, action: PayloadAction<HistoryState['modality']>) => {
      state.modality = action.payload;
    },
    setPresidentModal: (state, action: PayloadAction<HistoryState['presidentModal']>) => {
      state.presidentModal = action.payload;
      if (!action.payload) {
        state.president = null;
      }
    },
  },
});

export const { setPresidentModal, setAppTitle, setModality, setPresident } = historySlice.actions;

export default historySlice.reducer;
